import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InfoStoreModule } from '@wonder-core-ng/info-store/info-store.module';
import { AuthHttpInterceptor } from '@wonder-core-ng/session-store/auth-http.interceptor.service';
import { DashboardApiService } from './dashboard.api.service';
import { DashboardEffects } from './dashboard.effects';
import * as fromDashboard from './dashboard.reducer';
import { DashboardService } from './dashboard.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromDashboard.dashboardFeatureKey, fromDashboard.reducer),
    EffectsModule.forFeature([DashboardEffects]),
    InfoStoreModule,
  ],
  providers: [
    DashboardApiService,
    DashboardService,
    provideHttpClient(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class DashboardStoreModule {}
